"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var AdminRequest;
(function (AdminRequest) {
    var Create = (function (_super) {
        __extends(Create, _super);
        function Create() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = undefined;
            _this.lastName = undefined;
            _this.email = undefined;
            _this.address = undefined;
            _this.phone = undefined;
            _this.active = undefined;
            return _this;
        }
        return Create;
    }(BaseModel_1["default"]));
    AdminRequest.Create = Create;
    var Update = (function (_super) {
        __extends(Update, _super);
        function Update() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.name = undefined;
            _this.lastName = undefined;
            _this.email = undefined;
            _this.address = undefined;
            _this.phone = undefined;
            _this.active = undefined;
            return _this;
        }
        return Update;
    }(BaseModel_1["default"]));
    AdminRequest.Update = Update;
    var UpdateAnyUser = (function (_super) {
        __extends(UpdateAnyUser, _super);
        function UpdateAnyUser() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.name = undefined;
            _this.lastName = undefined;
            _this.email = undefined;
            _this.instituteName = undefined; // only schools
            _this.companyName = undefined; // only consignee
            _this.companyAddress = undefined; // only consignee
            _this.rut = undefined; // only consignee
            _this.address = undefined;
            _this.phone = undefined;
            _this.active = undefined;
            return _this;
        }
        return UpdateAnyUser;
    }(BaseModel_1["default"]));
    AdminRequest.UpdateAnyUser = UpdateAnyUser;
})(AdminRequest = exports.AdminRequest || (exports.AdminRequest = {}));
var AdminResponse;
(function (AdminResponse) {
    var Admin = (function (_super) {
        __extends(Admin, _super);
        function Admin() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.name = undefined;
            _this.lastName = undefined;
            _this.email = undefined;
            _this.userRoleId = undefined;
            _this.address = undefined;
            _this.number = undefined;
            _this.apt = undefined;
            _this.city = undefined;
            _this.departament = undefined;
            _this.zip = undefined;
            _this.phone = undefined;
            _this.active = undefined;
            return _this;
        }
        return Admin;
    }(BaseModel_1["default"]));
    AdminResponse.Admin = Admin;
    var UpdateAnyUser = (function (_super) {
        __extends(UpdateAnyUser, _super);
        function UpdateAnyUser() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.name = undefined;
            _this.lastName = undefined;
            _this.email = undefined;
            _this.instituteName = undefined; // only schools
            _this.companyName = undefined; // only consignee
            _this.companyAddress = undefined; // only consignee
            _this.rut = undefined; // only consignee
            _this.address = undefined;
            _this.number = undefined;
            _this.apt = undefined;
            _this.city = undefined;
            _this.departament = undefined;
            _this.zip = undefined;
            _this.phone = undefined;
            _this.active = undefined;
            return _this;
        }
        return UpdateAnyUser;
    }(BaseModel_1["default"]));
    AdminResponse.UpdateAnyUser = UpdateAnyUser;
    var All = (function (_super) {
        __extends(All, _super);
        function All(objects, length, offset, pagination) {
            if (length === void 0) { length = 0; }
            if (offset === void 0) { offset = 0; }
            if (pagination === void 0) { pagination = 100; }
            var _this = _super.call(this) || this;
            _this.objects = undefined;
            _this.length = 0;
            _this.offset = 0;
            _this.pagination = 100;
            _this.objects = objects;
            _this.length = length;
            _this.offset = offset;
            _this.pagination = pagination;
            return _this;
        }
        return All;
    }(BaseModel_1["default"]));
    AdminResponse.All = All;
})(AdminResponse = exports.AdminResponse || (exports.AdminResponse = {}));



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/admin.js
// module id = ../model/dist/models/admin.js
// module chunks = main